import { inject } from '@angular/core';
import { HearingEnrollmentStateService } from './workflow-registry-diagnostics/hearing-enrollment-state.service';
import type { CanDeactivateFn } from '@angular/router';
import { BusinessCalendarDraftStateService } from './business-calendars/business-calendar-draft-state.service';
import { WorkflowDraftDirtyStateService } from './workflow-registry-diagnostics/workflow-draft-dirty-state.service';
import { PlatformOperationsStateService } from './operations/platform-operations-state.service';
import { RecurringScheduleStateService } from './operations/recurring-schedules/recurring-schedule-state.service';
import { ReasonCatalogDraftStateService } from './reason-catalogs/reason-catalog-draft-state.service';
import { AlertTemplateDraftStateService } from './alert-templates/alert-template-draft-state.service';

import { NoticeFidelityStateService } from './notice-fidelity/notice-fidelity-state.service';
import { DocumentAssetsStateService } from './document-assets/document-assets-state.service';
import { TerminologyEditorStateService } from './terminology/terminology-editor-state.service';

/** Every admin route hosts the same tabs; protect pending editor and recovery actions. */
export const platformAdminNavigationGuard: CanDeactivateFn<unknown> = () => {
  const notices = inject(NoticeFidelityStateService);
  const assets = inject(DocumentAssetsStateService);
  const terminology = inject(TerminologyEditorStateService);
  const schedule = inject(RecurringScheduleStateService);
  const reasons = inject(ReasonCatalogDraftStateService);
  const alerts = inject(AlertTemplateDraftStateService);
  if (
    inject(PlatformOperationsStateService).isOperationInProgress() || inject(HearingEnrollmentStateService).busy() ||
    schedule.isOperationInProgress() ||
    reasons.busy() || alerts.busy() || notices.busy() || assets.busy() || terminology.busy()
  )
    return false;
  const workflow = inject(WorkflowDraftDirtyStateService);
  const calendar = inject(BusinessCalendarDraftStateService);
  const allowed = workflow.confirmNavigation();
  const editorsAllowed =
    typeof allowed === 'boolean'
      ? allowed && calendar.confirmNavigation()
      : allowed.then((result) =>
          result ? calendar.confirmNavigation() : false,
        );
  const previous =
    typeof editorsAllowed === 'boolean'
      ? editorsAllowed && schedule.confirmNavigation()
      : editorsAllowed.then((result) =>
          result ? schedule.confirmNavigation() : false,
        );
  const otherEditors = typeof previous === 'boolean'
    ? previous && reasons.confirmNavigation()
    : previous.then((result) => (result ? reasons.confirmNavigation() : false));
  const alertEditors = typeof otherEditors === 'boolean'
    ? otherEditors && alerts.confirmNavigation()
    : otherEditors.then(result => result ? alerts.confirmNavigation() : false);
  const noticeEditors = typeof alertEditors === 'boolean' ? alertEditors && notices.confirmNavigation() : alertEditors.then(result => result ? notices.confirmNavigation() : false);
  const assetEditors = typeof noticeEditors === 'boolean' ? noticeEditors && assets.confirmNavigation() : noticeEditors.then(result => result ? assets.confirmNavigation() : false);
  const enrollment=inject(HearingEnrollmentStateService);
  const terminologyEditors=typeof assetEditors === 'boolean' ? assetEditors && terminology.confirmNavigation() : assetEditors.then(result => result ? terminology.confirmNavigation() : false);
  return typeof terminologyEditors === 'boolean' ? terminologyEditors && enrollment.confirmNavigation() : terminologyEditors.then(result=>result?enrollment.confirmNavigation():false);
};
